import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { createAgreement } from '../AgreementsQueries';

export const useCreateAgreement = ({ onSuccess }: { onSuccess: () => void }) => {
    const [createAgreementData, createAgreementStatus, createAgreementError, createAgreementRequest] = useRequest({
        requestId: 'createAgreement',
        query: createAgreement,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });
    const [resetCreatingData] = useResetStoreData({ requestId: 'createAgreement' });

    const isCreatingInProgress = createAgreementStatus === RequestStatus.FETCHING;

    return {
        createAgreementData: createAgreementData?.uerCreateContractChange,
        createAgreementStatus,
        createAgreementError,
        createAgreementRequest,
        resetCreatingData,
        isCreatingInProgress,
    };
};
